import React, { forwardRef } from "react";
import { Box, Checkbox, Input } from "@chakra-ui/react";

type InputCheckboxProps = {
  name: string;
  value?: boolean;
  disabled?: boolean;
  fontSize?: string;
  size?: string;
  padding?: string;
  onChange?: (checked: boolean) => void;
  dataTestId?: string;
};

export const InputCheckbox = forwardRef<HTMLInputElement, InputCheckboxProps>((props, ref) => {
  const { name, value, disabled, fontSize = "lg", size = "lg", padding = "4", onChange } = props;
  const dataTestId = props.dataTestId ?? name;

  return (
    <Box
      sx={{
        ":has(input:checked)": {
          borderColor: "blue.500",
          outline: "1px solid",
          outlineColor: "blue.500",
          backgroundColor: "blue.50",
        },
        ":has(input:focus)": {
          outline: "2px solid",
          outlineColor: "blue.500",
          outlineOffset: "2px",
        },
        ":has(input:disabled)": {
          borderColor: "gray.500",
          outlineColor: "gray.50",
          backgroundColor: "white",
          color: "gray.500",
        },
        ":has(input:disabled:checked)": {
          borderColor: "black",
          outlineColor: "black",
          backgroundColor: "gray.50",
        },
        ".chakra-checkbox__label": {
          opacity: 1,
          color: "black",
        },
      }}
      border="1px solid"
      borderColor="gray.300"
      borderRadius="md"
      fontSize={fontSize}
      _hover={{
        borderColor: "blue.500",
      }}
    >
      <Checkbox
        data-testid={dataTestId}
        isChecked={value}
        disabled={disabled}
        padding={padding}
        _disabled={{
          opacity: 1,
          color: "black",
        }}
        width="full"
        borderColor="gray.500"
        size={size}
        onChange={(e) => onChange?.(e.target.checked)}
      >
        {name}
      </Checkbox>
    </Box>
  );
});
